(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jarvis-card-cart"] && !Shopify.designMode) return;
  try {
    /* Two things, both riding on Horizon's own modules rather than beside them:
     1. `jarvis-quick-view-component`: Horizon's QuickAddComponent, told which product by a
        data attribute because the house card is not a `product-card`.
     2. The button's lasting state. Horizon's product-form.js does every add (the card's
        own and the quick view's) and dispatches the STANDARD cart event (@shopify/events ->
        StandardEvents.cartLinesUpdate); this only listens. The event name is imported,
        never typed, so it follows the platform. */
  (() => {
    if (window.__jarvisCardCart) return;
    window.__jarvisCardCart = true;

    import('@theme/quick-add')
      .then(({ QuickAddComponent }) => {
        if (!QuickAddComponent || customElements.get('jarvis-quick-view-component')) return;
        class JarvisQuickView extends QuickAddComponent {
          get productPageUrl() {
            return this.dataset.productUrl || '';
          }
        }
        customElements.define('jarvis-quick-view-component', JarvisQuickView);
      })
      .catch(() => {
        /* No quick view: the link underneath still goes to the product page. */
      });

    const ADDED_FOR_MS = 2400;
    const boxes = () => document.querySelectorAll('[data-jarvis-cart]');
    let opener = null;

    document.addEventListener(
      'click',
      (event) => {
        const link = event.target instanceof Element ? event.target.closest('.jarvis-cart__quick a') : null;
        if (link) opener = link.closest('[data-jarvis-cart]');
      },
      true
    );

    /* Which products are in the cart NOW. Read after every change, from any source (the
       drawer's remove button included), so a card never claims a line that has gone. */
    const sync = async () => {
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const res = await fetch(root + 'cart.js', { credentials: 'same-origin' });
        if (!res.ok) return;
        const cart = await res.json();
        const ids = new Set((cart.items || []).map((i) => String(i.product_id)));
        for (const box of boxes()) {
          if (ids.has(box.dataset.productId)) box.dataset.inCart = 'true';
          else delete box.dataset.inCart;
        }
      } catch (e) {
        /* A failed read leaves the cards as the page rendered them. */
      }
    };

    const flash = (box) => {
      box.dataset.state = 'added';
      clearTimeout(box.jarvisAddedTimer);
      box.jarvisAddedTimer = setTimeout(() => {
        delete box.dataset.state;
      }, ADDED_FOR_MS);
    };

    const onLinesUpdate = (event) => {
      const origin = event.target instanceof Element ? event.target : null;
      let box = origin ? origin.closest('[data-jarvis-cart]') : null;
      /* An add made inside the quick view belongs to the card that opened it. */
      if (!box && origin && origin.closest('quick-add-dialog') && opener) box = opener;
      const adding = Boolean(box) && event.action === 'add';
      /* Said at once, the way Horizon's own tick is: the round trip takes about a second,
         and a button that does nothing for a second gets pressed twice. Taken back if the
         cart refuses the line. */
      if (adding) box.dataset.state = 'added';
      Promise.resolve(event.promise)
        .then((result) => {
          if (adding) {
            if (result && result.detail && result.detail.didError) delete box.dataset.state;
            else flash(box);
          }
          return sync();
        })
        .catch(() => {
          if (adding) delete box.dataset.state;
          return sync();
        });
    };

    import('@shopify/events')
      .then(({ StandardEvents }) => {
        document.addEventListener(StandardEvents.cartLinesUpdate, onLinesUpdate);
      })
      .catch(() => {});
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jarvis-hero-fx"] && !Shopify.designMode) return;
  try {
    /*
   * The hero's pointer controller: ~40 lines, no library, loaded deferred by Shopify.
   * On a fine pointer, and only when motion is lively or bold and the shopper has not
   * asked for reduced motion, it writes --fx-px/--fx-py (-1..1) on the hero, once per
   * frame, for the parallax, the card tilt and the leaning button to read. Nothing loops,
   * so there is nothing to pause off screen (2026-09-23: every auto-play rests by 5 s).
   * Everything it does is decoration: with no script the hero is complete and still.
   */
  class JarvisHeroFx extends HTMLElement {
    connectedCallback() {
      this.hero = this.closest('[data-hero]');
      if (!this.hero) return;
      const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (still || !fine || this.hero.dataset.motion === 'calm') return;
      this.frame = 0;
      this.onMove = this.#move.bind(this);
      this.onLeave = this.#leave.bind(this);
      this.hero.addEventListener('pointermove', this.onMove, { passive: true });
      this.hero.addEventListener('pointerleave', this.onLeave, { passive: true });
    }

    disconnectedCallback() {
      if (!this.hero || !this.onMove) return;
      this.hero.removeEventListener('pointermove', this.onMove);
      this.hero.removeEventListener('pointerleave', this.onLeave);
      cancelAnimationFrame(this.frame);
    }

    #move(event) {
      if (this.frame) return;
      const { clientX, clientY } = event;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        const box = this.hero.getBoundingClientRect();
        const x = ((clientX - box.left) / box.width) * 2 - 1;
        const y = ((clientY - box.top) / box.height) * 2 - 1;
        this.hero.style.setProperty('--fx-px', x.toFixed(3));
        this.hero.style.setProperty('--fx-py', y.toFixed(3));
      });
    }

    #leave() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.hero.style.setProperty('--fx-px', '0');
      this.hero.style.setProperty('--fx-py', '0');
    }
  }

  if (!customElements.get('jarvis-hero-fx')) customElements.define('jarvis-hero-fx', JarvisHeroFx);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jarvis-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jarvis-share')) {
    class JarvisShare extends HTMLElement {
      connectedCallback() {
        const native = this.querySelector('[data-share-native]');
        const coarse = window.matchMedia('(pointer: coarse)').matches;
        if (native && typeof navigator.share === 'function' && coarse) {
          native.hidden = false;
          this.querySelectorAll('[data-share-covered]').forEach((el) => {
            el.hidden = true;
          });
          native.querySelector('button').addEventListener('click', () => {
            navigator.share({ title: this.dataset.title, url: this.dataset.url }).catch(() => {});
          });
        }
        const copy = this.querySelector('[data-share-copy]');
        if (copy && navigator.clipboard && window.isSecureContext) {
          copy.hidden = false;
          copy.querySelector('button').addEventListener('click', () => this.copyLink(copy));
        }
      }

      copyLink(copy) {
        const label = copy.querySelector('[data-share-copy-text]');
        const status = this.querySelector('[data-share-status]');
        navigator.clipboard.writeText(this.dataset.url).then(
          () => {
            label.textContent = 'Link copied';
            if (status) status.textContent = 'Link copied';
            window.clearTimeout(this.resetTimer);
            this.resetTimer = window.setTimeout(() => {
              label.textContent = 'Copy link';
              if (status) status.textContent = '';
            }, 2500);
          },
          () => {}
        );
      }
    }
    customElements.define('jarvis-share', JarvisShare);
  }
  } catch(e) { console.error(e); }
})();

})();
